import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    background-color: rgba(0, 0, 0, 0);
    visibility: hidden;
  }

  to {
    background-color: rgba(0, 0, 0, 0.5);
    visibility: visible;
  }
`;

export const fadeOut = keyframes`
  from {
    background-color: rgba(0, 0, 0, 0.5);
    visibility: visible;
  }

  to {
    background-color: rgba(0, 0, 0, 0);
    visibility: hidden;
  }
`;

export const slideIn = keyframes`
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0%);
  }
`;

export const slideOut = keyframes`
  from {
    transform: translateX(0%);
  }

  to {
    transform: translateX(100%);
  }
`;
